import { render, staticRenderFns } from "./Neurodegenerative-disorders.vue?vue&type=template&id=355404c4"
var script = {}
import style0 from "./Neurodegenerative-disorders.vue?vue&type=style&index=0&id=355404c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports